import { getReferralNeeded } from './getReferralNeeded/getReferralNeeded';

export const endpoint = '/api/v1/referral-needed/';

const referralNeeded = {
  getReferralNeeded,
};

export default referralNeeded;
